import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';

interface OnuDuplicadasModalProps {
  open: boolean;
  onClose: () => void;
  serialsDuplicados: { serial: string; count: number }[];
  onSerialClick?: (serial: string) => void;
}

const OnuDuplicadasModal: React.FC<OnuDuplicadasModalProps> = ({
  open,
  onClose,
  serialsDuplicados,
  onSerialClick
}) => {
  const handleSerialClick = (serial: string) => {
    onSerialClick?.(serial);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>ONUs Duplicadas (mesmo serial GPON)</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Serial (GPON)</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>Qtd</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {serialsDuplicados.map(({ serial, count }) => (
                <TableRow
                  key={serial}
                  hover
                  sx={{ cursor: onSerialClick ? 'pointer' : 'default' }}
                  onClick={() => onSerialClick && handleSerialClick(serial)}
                >
                  <TableCell sx={{ fontFamily: 'monospace' }}>{serial}</TableCell>
                  <TableCell align="right">{count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OnuDuplicadasModal;
